import { Value } from '@philips-internal/oswald-ui-core';

export class DoubleConferenceUtils {
  static validateParams(paramsRoute: Record<string, Value>, numberPrescription?: number, solutionSequence?: number): void {
    if (numberPrescription && solutionSequence) {
      paramsRoute.numberPrescription = numberPrescription,
      paramsRoute.solutionSequence = solutionSequence;
    } else if (numberPrescription) {
      paramsRoute.numberPrescription = numberPrescription;
    }
  }
}
